module.exports = __webpack_public_path__ + "img/bg_yxds.d3325da5.png";